// extracted by mini-css-extract-plugin
export default {"outer":"Cursor_outer__4YpUc","change":"Cursor_change__IqoHn"};